<template>
  <v-dialog v-model="dialog.display" max-width="550px">
    <v-card>
      <v-card-title>
        <span class="text-subtitle-2">
          <span class="font-weight-bold secondary-font">{{
            $t("cga.manager.filter.title")
          }}</span>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-7 pt-3">
        <v-text-field
          append-icon="mdi-identifier"
          :label="$t('commons.fields.identifier.title')"
          v-model="filters.identifier.value"
          clearable
        ></v-text-field>
        <v-text-field
          append-icon="mdi-account-outline"
          :label="$t('commons.fields.username.title')"
          v-model="filters.username.value"
          clearable
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="mt-0 px-5">
        <v-spacer></v-spacer>
        <v-btn text @click="reset()">{{ $t("btn.reset") }}</v-btn>
        <v-btn
          text
          color="primary"
          class="font-weight-bold"
          @click="filter()"
          >{{ $t("btn.filter") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: function () {
        return {
          display: false,
        };
      },
    },
  },
  data: () => ({
    filters: {
      identifier: {
        operator: "$contL",
        value: null,
      },
      username: {
        operator: "$contL",
        value: null,
      },
    },
  }),
  methods: {
    filter() {
      this.$emit("filter", this.filters);
      this.dialog.display = false;
    },
    reset() {
      this.$emit("filter", {});
      for (const prop in this.filters) {
        this.filters[prop].value = null;
      }
      this.dialog.display = false;
    },
  },
};
</script>